const whatsAppMessages = 'whatsAppMessages';

export const FETCH_WHATSAPP_MESSAGES_REQUEST =
  `${whatsAppMessages}/FETCH_WHATSAPP_MESSAGES_REQUEST` as const;
export const FETCH_WHATSAPP_MESSAGES_RESPONSE =
  `${whatsAppMessages}/FETCH_WHATSAPP_MESSAGES_RESPONSE` as const;
